import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AssetItem, AssetItemColor, AssetItemName } from './styles';
import { assetColor } from '../../themes/assetColor';
import { MoneyfarmThemeLight } from '../../themes/MoneyfarmLight';
import { Accordion } from '../Accordion';
export var AllocationList = function (_a) {
  var assets = _a.assets,
    _b = _a.theme,
    theme = _b === void 0 ? MoneyfarmThemeLight : _b;
  return _jsx("div", {
    children: assets.map(function (asset) {
      return _jsxs(AssetItem, {
        children: [_jsx(AssetItemColor, {
          color: assetColor(theme, asset.id)
        }), _jsx(AssetItemName, {
          children: _jsx(Accordion, {
            additionalText: asset.weightFormatted,
            title: asset.name,
            titleTextStyles: {
              flexBasis: '300px',
              marginRight: '0'
            },
            children: asset.description
          })
        })]
      }, asset.id);
    })
  });
};